import Cookies from 'js-cookie';

$(document).ready(() => {
    const PINNED_COOKIE_NAME = 'pinned_trainers';

    $('.list.trainers').on('click', '[data-action="toggle-favorite"]', ev => {
        ev.preventDefault();
        const
            $target        = $(ev.target),
            $item          = $target.closest('.list > .item'),
            $button        = $item.find('button[data-action="toggle-favorite"]'),
            $pinnable      = $item.find('a[data-action="toggle-favorite"] i.fa'),
            id             = $item.data('id'),
            shouldBePinned = !$pinnable.hasClass('pinned'),
            cookieValue    = Cookies.get(PINNED_COOKIE_NAME),
            oldPinnedIds   = cookieValue ? JSON.parse(cookieValue) : [],
            newPinnedIds   = oldPinnedIds.includes(id) ? oldPinnedIds.filter(v => v !== id) : [...oldPinnedIds, id];

        Cookies.set(PINNED_COOKIE_NAME, JSON.stringify(newPinnedIds), {
            expires: 3650,
        });

        $pinnable
            .removeClass('fa-star fa-star-o pinned')
            .addClass('fa ' + (shouldBePinned ? 'fa-star pinned' : 'fa-star-o'));

        $button
            .empty()
            .append($item.data(shouldBePinned ? 'pinned-title' : 'unpinned-title'))   // @todo: Rework after Laravel translations extract
            .append('&nbsp;')
            .append(
                $('<i />', {
                    'class': 'fa fa-fw fa-lg ' + (shouldBePinned ? 'fa-star' : 'fa-star-o'),
                })
            );
    });
});
